"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xMRealityOptions = void 0;
var xMRealityOptions = exports.xMRealityOptions = {
  options: function options(_ref) {
    var store = _ref.store;
    var platformStore = store.platform.store;
    var domainId = platformStore.platform.organization.id;
    return {
      fetchPolicy: 'network-only',
      variables: {
        domainId: domainId
      }
    };
  },
  name: 'xMRealityQuery',
  skip: function skip(_ref2) {
    var canUseXmReality = _ref2.canUseXmReality;
    return !canUseXmReality;
  }
};
//# sourceMappingURL=query-options.js.map